// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "665bd3c5c6b9baf6e5be" + ".chunk.js";
};